import styled from 'styled-components';
import { fromOADate } from '../../../helpers/datetime';
import { useTranslation } from 'react-i18next';
import { kassimBlue } from '../../../style/theme';

const StatusValueContainer = styled.div``;
const Label = styled.div`
    display: ${({ $inline }) => ($inline ? 'inline-block' : 'block')};
    margin-right: 4px;
    min-width: 80px;
    /* color: #eee; */
`;
const StatusValue = styled.div`
    display: inline-block;
    margin-right: 4px;
    font-weight: bold;
    font-size: 120%;
    /* color: #fff; */
`;

const MainContainer = styled.div`
    color: ${kassimBlue};
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
    justify-content: space-evenly;
`;

const StatusPanel = ({ status, smallScreen, ...props }) => {
    const { t } = useTranslation();
    const {
        simBeg,
        simEnd,
        stepBeg,
        stepEnd,
        step,
        steps,
        attempts,
        maxAttempts,
    } = status;

    return (
        <MainContainer {...props}>
            <StatusValueContainer>
                <Label $inline={!smallScreen}>{t('game.Cultivation')}:</Label>
                <StatusValue>
                    {t('dayMonth', { date: fromOADate(simBeg) })} -{' '}
                    {t('dayMonth', { date: fromOADate(simEnd) })}
                </StatusValue>
            </StatusValueContainer>

            <StatusValueContainer>
                <Label $inline={!smallScreen}>{t('game.Period')}:</Label>
                <StatusValue>
                    {step + 1}/{steps}
                </StatusValue>
                <StatusValue>
                    {t('dayMonth', { date: fromOADate(stepBeg) })} -{' '}
                    {t('dayMonth', { date: fromOADate(stepEnd) })}
                </StatusValue>
            </StatusValueContainer>

            <StatusValueContainer>
                <Label $inline={!smallScreen}>{t('game.Attempts')}:</Label>
                <StatusValue>
                    {attempts}/{maxAttempts}
                </StatusValue>
            </StatusValueContainer>
        </MainContainer>
    );
};

export default StatusPanel;
